import React from "react";
import "./ProfilePic.scss";

export default function ProfileImage({url}) {
  return <img className="profile-pic" src={url} />;
}
